import "leaflet"
import 'leaflet/dist/leaflet.css';
import "leaflet-fullscreen"
import 'leaflet-fullscreen/dist/leaflet.fullscreen.css';
import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    activeEntryId: Number,
    activeIconPath: String,
    pastIconPath: String
  }
  static targets = ["container"]

  markers = new Map();

  connect() {
    this.initMap();

  }

  onNav(event) {
    this.activeEntryIdValue = parseInt(event.params.entryId);
    this.navigateToMarker(this.activeEntryIdValue)
    
  }

  async initMap() {
    const L = await import("leaflet");
    this.map = L.map(this.containerTarget, {});
    L.tileLayer('https://api.maptiler.com/maps/outdoor-v2/{z}/{x}/{y}.png?key=gnxcJuntvIiXEF2XFXLc', {
      // maxZoom: 19,
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors & <a href="https://www.maptiler.com/">MapTiler</a>'
 }).addTo(this.map);
    this.map.addControl(new L.Control.Fullscreen({
      title: {
        'false': 'View Fullscreen',
        'true': 'Exit Fullscreen'
      }
    }));
    this.activeIcon = L.icon({
      iconUrl: this.activeIconPathValue,
      iconSize: [50, 50],
    });

    this.pastIcon = L.icon({
      className: "marker-blue",
      iconUrl: this.pastIconPathValue,
      iconSize: [40, 40],
    });
    // call api to get the markers controller: blog_entries_controller.rb action: index
    const data = await fetch('/blog_entries.json').then(response => response.json());
    const entryWithFirstCoordinate = data[0]
    if (entryWithFirstCoordinate) {
      this.map.setView([entryWithFirstCoordinate.coordinates[0], entryWithFirstCoordinate.coordinates[1]], 10);
    }
    const entriesWithCoordinates = data;
    this.drawRoute(entriesWithCoordinates, L);
    this.drawMarkers(L, entriesWithCoordinates);
  }

  drawMarkers(L, entriesWithCoordinates) {


    entriesWithCoordinates.forEach((entry, index) => {
      const [latitude, longitude] = entry.coordinates;
      const turboFrame = document.querySelector(`turbo-frame#blog_entry`);
      const marker = L.marker([latitude, longitude], {icon: this.activeEntryIdValue.toString() === entry.id.toString() ? this.activeIcon : this.pastIcon})
        .addTo(this.map)
        .bindTooltip(new Date(entry.created_at).toLocaleString({
          timeZone: "Asia/Bangkok",
          day: 'numeric',
          month: 'long',
          year: 'numeric'
        })).on('click', () => {
          turboFrame.src = `/blog_entries/${entry.id}`
          this.activeEntryIdValue = entry.id;
        });
      this.markers.set(entry.id, marker)
    });
  }

  drawRoute(entriesWithCoordinates, L) {
    const pointList = entriesWithCoordinates.map(entry => new L.LatLng(entry.coordinates[0], entry.coordinates[1]));

    if (pointList.length > 2) {
      const firstpolyline = new L.Polyline(pointList, {
        color: 'red',
        weight: 3,
        dashArray: '10, 10', dashOffset: '10',
        opacity: 0.5,
        smoothFactor: 1
      });
      this.map.addLayer(firstpolyline);
    }
  }

  activeEntryIdValueChanged() {
    this.makeMarkerActive(this.activeEntryIdValue);
  }

  disconnect() {
    this.map.remove()
  }

  makeMarkerActive(id) {
    this.markers.forEach((marker, key) => {
      marker.setIcon(id.toString() === key.toString() ? this.activeIcon : this.pastIcon).update();
    });
  }

  navigateToMarker(id){

   this.map.panTo(this.markers.get(id).getLatLng());
  }
}
